(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[0,311,255,60],[0,0,167,135],[0,253,275,56],[169,0,289,56],[0,137,386,56],[257,311,181,56],[0,195,278,56],[277,253,178,56],[169,58,282,56],[280,195,120,56]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_1309 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_1308 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_1307 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_1306 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_1305 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_1304 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_1303 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_1302 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_1301 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_1300 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.size_1920x1080 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape.setTransform(960,540);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_1920x1080, new cjs.Rectangle(0,0,1920,1080), null);


(lib.size_90x90 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-45,45).lineTo(-45,-45).lineTo(45,-45).lineTo(45,45).closePath();
	this.shape.setTransform(45,45);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_90x90, new cjs.Rectangle(0,0,90,90), null);


(lib.logo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.CachedBmp_1309();
	this.instance.setTransform(0,20.05,0.5,0.5);

	this.instance_1 = new lib.CachedBmp_1308();
	this.instance_1.setTransform(22.1,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,127.5,67.5);


(lib.vertical = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,1,1).moveTo(0,-8).lineTo(0,8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vertical, new cjs.Rectangle(-1,-9,2,18), null);


(lib.square = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// square
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-4,4).lineTo(-4,-4).lineTo(4,-4).lineTo(4,4).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square, new cjs.Rectangle(-4,-4,8,8), null);


(lib.ball = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ball
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-2.8,2.9).curveTo(-4,1.7,-4,0).curveTo(-4,-1.6,-2.8,-2.8).curveTo(-1.6,-4,0,-4).curveTo(1.6,-4,2.8,-2.8).curveTo(4,-1.6,4,0).curveTo(4,1.7,2.8,2.9).curveTo(1.6,4,0,4).curveTo(-1.6,4,-2.8,2.9).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ball, new cjs.Rectangle(-4,-4,8,8), null);


(lib.pseudo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0.498)").beginStroke().moveTo(-67.4,30).lineTo(-67.4,-30).lineTo(67.4,-30).lineTo(67.4,30).closePath();
	this.shape.setTransform(67.4,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pseudo, new cjs.Rectangle(0,0,134.8,60), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrow_up, new cjs.Rectangle(-22.6,0,45.2,22.7), null);


(lib.solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(4,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.solid, new cjs.Rectangle(-2,-2,1924,4), null);


(lib.gradient = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#5BC3BE","#1F4F6E"],[0,1],-680,0,680,0).beginStroke().moveTo(-680,2).lineTo(-680,-2).lineTo(680,-2).lineTo(680,2).closePath();
	this.shape.setTransform(680,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.gradient, new cjs.Rectangle(0,-2,1360,4), null);


(lib._double = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#666666").setStrokeStyle(2,1,1).moveTo(50,-30).lineTo(-550,-30).moveTo(550,30).lineTo(-250,30);
	this.shape.setTransform(550,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib._double, new cjs.Rectangle(-1,-1,1102,62), null);


(lib.logo_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.text = new cjs.Text("Before", "200px 'Montserrat Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 278;
	this.text.lineWidth = 676;
	this.text.parent = this;
	this.text.setTransform(233.35,2);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_1, new cjs.Rectangle(-106.5,0,679.7,279.8), null);


(lib.button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-64,-64,128,128);


(lib.title = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.instance = new lib.vertical();
	this.instance.setTransform(1215.7,13);
	this.instance.visible = false;

	this.instance_1 = new lib.vertical();
	this.instance_1.setTransform(1071.5,13);
	this.instance_1.visible = false;

	this.instance_2 = new lib.vertical();
	this.instance_2.setTransform(833.4,13);
	this.instance_2.visible = false;

	this.instance_3 = new lib.vertical();
	this.instance_3.setTransform(634.5,13);
	this.instance_3.visible = false;

	this.instance_4 = new lib.vertical();
	this.instance_4.setTransform(1410.4,13);
	this.instance_4.visible = false;

	this.instance_5 = new lib.vertical();
	this.instance_5.setTransform(450.8,13);
	this.instance_5.visible = false;

	this.instance_6 = new lib.vertical();
	this.instance_6.setTransform(273.8,13);
	this.instance_6.visible = false;

	this.instance_7 = new lib.vertical();
	this.instance_7.setTransform(88,13);
	this.instance_7.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// square
	this.instance_8 = new lib.square();
	this.instance_8.setTransform(1215.7,13);
	this.instance_8.visible = false;

	this.instance_9 = new lib.square();
	this.instance_9.setTransform(1071.5,13);
	this.instance_9.visible = false;

	this.instance_10 = new lib.square();
	this.instance_10.setTransform(833.4,13);
	this.instance_10.visible = false;

	this.instance_11 = new lib.square();
	this.instance_11.setTransform(1410.4,13);
	this.instance_11.visible = false;

	this.instance_12 = new lib.square();
	this.instance_12.setTransform(634.5,13);
	this.instance_12.visible = false;

	this.instance_13 = new lib.square();
	this.instance_13.setTransform(450.8,13);
	this.instance_13.visible = false;

	this.instance_14 = new lib.square();
	this.instance_14.setTransform(273.8,13);
	this.instance_14.visible = false;

	this.instance_15 = new lib.square();
	this.instance_15.setTransform(88,13);
	this.instance_15.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8}]}).wait(1));

	// ball
	this.instance_16 = new lib.ball();
	this.instance_16.setTransform(1337.1,13);

	this.instance_17 = new lib.ball();
	this.instance_17.setTransform(1171.2,13);

	this.instance_18 = new lib.ball();
	this.instance_18.setTransform(1007.1,13);

	this.instance_19 = new lib.ball();
	this.instance_19.setTransform(792.9,13);

	this.instance_20 = new lib.ball();
	this.instance_20.setTransform(524.7,13);

	this.instance_21 = new lib.ball();
	this.instance_21.setTransform(308.6,13);

	this.instance_22 = new lib.ball();
	this.instance_22.setTransform(96,13);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16}]}).wait(1));

	// title
	this.instance_23 = new lib.CachedBmp_1307();
	this.instance_23.setTransform(133.6,0,0.5,0.5);

	this.instance_24 = new lib.CachedBmp_1306();
	this.instance_24.setTransform(1374.7,0,0.5,0.5);

	this.instance_25 = new lib.CachedBmp_1305();
	this.instance_25.setTransform(562.3,0,0.5,0.5);

	this.instance_26 = new lib.CachedBmp_1304();
	this.instance_26.setTransform(1208.8,0,0.5,0.5);

	this.instance_27 = new lib.CachedBmp_1303();
	this.instance_27.setTransform(830.5,0,0.5,0.5);

	this.instance_28 = new lib.CachedBmp_1302();
	this.instance_28.setTransform(1044.7,0,0.5,0.5);

	this.instance_29 = new lib.CachedBmp_1301();
	this.instance_29.setTransform(346.2,0,0.5,0.5);

	this.instance_30 = new lib.CachedBmp_1300();
	this.instance_30.setTransform(-1.5,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.title, new cjs.Rectangle(-1.5,0,1520.7,28), null);


(lib.effect_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {start:1,complete:10,end:19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// effect
	this.instance = new lib.arrow_up();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({y:-30},4).to({y:-22.65},2).to({y:-30},2).wait(1).to({y:0},9).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.6,-30,45.2,52.7);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line_solid
	this.instance = new lib.solid();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// line_gradient
	this.instance_1 = new lib.gradient();
	this.instance_1.setTransform(560,0);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// line_double
	this.instance_2 = new lib._double();
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FDB913").beginStroke().moveTo(-960,40).lineTo(-960,-40).lineTo(960,-40).lineTo(960,40).closePath();
	this.shape.setTransform(960,40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.background, new cjs.Rectangle(-2,-2,1924,82), null);


(lib.logo_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {none:1,small:2,medium:3,large:4};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(5));

	// background
	this.instance_2 = new lib.logo("synched",0);
	this.instance_2.setTransform(123.85,37.8,0.5224,0.5224,0,0,0,63.9,33.9);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(2).to({_off:false},0).wait(1).to({scaleX:0.7628,scaleY:0.7628,x:123.9,y:39.2},0).wait(1).to({scaleX:0.9512,scaleY:0.9512,x:123.95,y:39.25},0).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-110,40).lineTo(-110,-40).lineTo(110,-40).lineTo(110,40).closePath();
	this.shape.setTransform(125.0005,40,1.1364,1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,250,80);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1,frame02:2,frame03:3,frame04:4,frame05:5,frame06:6,frame07:7,frame08:8,frame09:9,frame10:10,frame11:11};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(12));

	// size
	this.instance = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(12));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.content_frame_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"start":1,"complete":30,"end":59};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectStart('index', 'before');
	}
	this.frame_29 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectComplete('index', 'before');
	}
	this.frame_59 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectEnd('index', 'before');
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(29).call(this.frame_29).wait(30).call(this.frame_59).wait(1));

	// logo
	this.instance = new lib.logo_1();
	this.instance.setTransform(726.65,360.1);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({alpha:1},28).wait(1).to({alpha:0},29).wait(1));

	// button
	this.btn_start = new lib.button();
	this.btn_start.name = "btn_start";
	this.btn_start.setTransform(952.25,795.4);
	this.btn_start._off = true;
	new cjs.ButtonHelper(this.btn_start, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_start).wait(29).to({_off:false},0).to({_off:true},2).wait(29));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#00FF00").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape.setTransform(952.25,795.4);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(29).to({_off:false},0).to({_off:true},2).wait(29));

	// size
	this.instance_1 = new lib.size_1920x1080();
	this.instance_1.setTransform(960,540,1,1,0,0,0,960,540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(60));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2,"frame03":3,"frame04":4,"frame05":5,"frame06":6,"frame07":7,"frame08":8,"frame09":9,"frame10":10};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(11));

	// arrow_up
	this.occ_animate = new lib.effect_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(38.45,0);
	this.occ_animate._off = true;

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(2).to({_off:false},0).wait(1).to({x:190.95},0).wait(1).to({x:372.4},0).wait(1).to({x:552.8},0).wait(1).to({x:744.15},0).wait(1).to({x:962.7},0).wait(1).to({x:1153.9},0).wait(1).to({x:1323.4},0).wait(1).to({x:1480.8},0).wait(1));

	// size
	this.instance = new lib.size_90x90();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(11));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1503.4,90);


(lib.content_frame_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.btn_page09 = new lib.button();
	this.btn_page09.name = "btn_page09";
	this.btn_page09.setTransform(1806.45,1039.05,1.1717,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page09, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page08 = new lib.button();
	this.btn_page08.name = "btn_page08";
	this.btn_page08.setTransform(1618.2,1039.05,0.7811,0.4688,0,0,0,0.8,0.1);
	new cjs.ButtonHelper(this.btn_page08, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page07 = new lib.button();
	this.btn_page07.name = "btn_page07";
	this.btn_page07.setTransform(1451.7,1039.05,0.8593,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page07, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page06 = new lib.button();
	this.btn_page06.name = "btn_page06";
	this.btn_page06.setTransform(1261.35,1039.05,1.1858,0.4688,0,0,0,0.3,0.1);
	new cjs.ButtonHelper(this.btn_page06, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page05 = new lib.button();
	this.btn_page05.name = "btn_page05";
	this.btn_page05.setTransform(1019.75,1039.05,1.5687,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page05, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page04 = new lib.button();
	this.btn_page04.name = "btn_page04";
	this.btn_page04.setTransform(777.25,1039.05,1.2499,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page04, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page03 = new lib.button();
	this.btn_page03.name = "btn_page03";
	this.btn_page03.setTransform(562.1,1039.05,1.2031,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page03, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page02 = new lib.button();
	this.btn_page02.name = "btn_page02";
	this.btn_page02.setTransform(388.5,1039.05,0.6008,0.4688,0,0,0,0.1,0.1);
	new cjs.ButtonHelper(this.btn_page02, 0, 1, 2, false, new lib.button(), 3);

	this.btn_back = new lib.button();
	this.btn_back.name = "btn_back";
	this.btn_back.setTransform(185.4,1040.05,1.9531,0.625,0,0,0,0.2,0.1);
	this.btn_back.visible = false;
	new cjs.ButtonHelper(this.btn_back, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_back},{t:this.btn_page02},{t:this.btn_page03},{t:this.btn_page04},{t:this.btn_page05},{t:this.btn_page06},{t:this.btn_page07},{t:this.btn_page08},{t:this.btn_page09}]}).wait(1));

	// marker
	this.occ_marker = new lib.marker();
	this.occ_marker.name = "occ_marker";
	this.occ_marker.setTransform(350,1080);

	this.timeline.addTween(cjs.Tween.get(this.occ_marker).wait(1));

	// marker_slider
	this.occ_marker_slider = new lib.arrow_up();
	this.occ_marker_slider.name = "occ_marker_slider";
	this.occ_marker_slider.setTransform(388.45,1057.35);
	this.occ_marker_slider.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_marker_slider).wait(1));

	// pseudo
	this.instance = new lib.pseudo();
	this.instance.setTransform(1146.7,1096.5);

	this.instance_1 = new lib.pseudo();
	this.instance_1.setTransform(1789.75,1096.5,0.6031,1);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// title
	this.instance_2 = new lib.title();
	this.instance_2.setTransform(360,1026);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// logo
	this.occ_logo = new lib.logo_2();
	this.occ_logo.name = "occ_logo";
	this.occ_logo.setTransform(60,1000);
	this.occ_logo.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo).wait(1));

	// background
	this.instance_3 = new lib.background();
	this.instance_3.setTransform(0,1000);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// background_dynamic
	this.occ_dynamic = new lib.background_dynamic();
	this.occ_dynamic.name = "occ_dynamic";
	this.occ_dynamic.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_dynamic).wait(1));

	// size
	this.instance_4 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.content_frame_02, new cjs.Rectangle(-2,0,1924,1170), null);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.frame01Index(this, 'index');
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(2));

	// ContentFrame
	this.occ_frame_01 = new lib.content_frame_01();
	this.occ_frame_01.name = "occ_frame_01";

	this.occ_frame_02 = new lib.content_frame_02();
	this.occ_frame_02.name = "occ_frame_02";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.occ_frame_01}]},1).to({state:[{t:this.occ_frame_02}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1922,1170);
// library properties:
lib.properties = {
	id: '8D6FF2B23DC06844BB2994587C24925D',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"./images/index_atlas_1.png", id:"index_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['8D6FF2B23DC06844BB2994587C24925D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = document.documentElement.clientWidth, ih = document.documentElement.clientHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
